<template>
  <div class="wrapper" id="pdf">
    <form class="contact-form" ref="form" @submit.prevent="save">
      <div class="md-layout">
        <div class="md-layout-item md-size-50">
          <md-field>
            <label>{{ $t("landing.formulaire.nom") }}*</label>
            <md-input v-model="name" type="text" name="username"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50">
          <md-field>
            <label>{{ $t("landing.formulaire.phone") }}*</label>
            <md-input
              @keypress="isNumberOnly"
              v-model="phone"
              type="text"
              name="phone"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-50">
          <md-field>
            <label>{{ $t("landing.formulaire.email") }}*</label>
            <md-input v-model="email" type="email" name="email"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50">
          <md-field>
            <label>{{ $t("landing.formulaire.nationalite") }}*</label>
            <md-input
              v-model="nationalite"
              type="text"
              name="nationalite"
            ></md-input>
          </md-field>
        </div>
      </div>

      <br />
      <div class="md-layout">
        <div class="md-layout-item md-size-50">
          <label>Date de naissance*</label>
          <md-field>
            <md-input v-model="date" type="date"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50">
          <label>Lieu de naissance*</label>
          <md-field>
            <md-input v-model="lieu" type="text"></md-input>
          </md-field>
        </div>
      </div>

      <!--      <md-field maxlength="5">-->
      <!--        <label>{{ $t("landing.formulaire.message") }}*</label>-->
      <!--        <md-textarea v-model="message"></md-textarea>-->
      <!--      </md-field>-->

      <div class="rad md-layout">
        <div class="md-layout-item md-size-50">
          <label>{{ $t("landing.formulaire.procedure") }}*</label>

          <br />
          <br />
          <md-radio v-model="procedure" name="procedure" value="Etude"
            >Etude</md-radio
          >

          <br />
          <md-radio v-model="procedure" name="procedure" value="Tourisme"
            >Tourisme</md-radio
          >

          <br />
          <md-radio v-model="procedure" name="procedure" value="Travail"
            >Travail</md-radio
          >

          <br />
          <md-radio v-model="procedure" name="procedure" value="Business"
            >Business</md-radio
          >
        </div>

        <div class="md-layout-item md-size-50">
          <label>{{ $t("landing.formulaire.niveau") }}*</label>

          <br />
          <br />
          <md-radio v-model="niveau" name="niveau" value="BAC">BAC</md-radio>

          <br />
          <md-radio v-model="niveau" name="niveau" value="Licence (L1 L2 L3)">
            Licence (L1 L2 L3)
          </md-radio>

          <br />
          <md-radio v-model="niveau" name="niveau" value="Master"
            >Master</md-radio
          >

          <br />
          <md-radio v-model="niveau" name="niveau" value="Doctorat"
            >Doctorat</md-radio
          >
        </div>
      </div>

      <md-field v-if="procedure === 'Etude'">
        <label>{{ $t("landing.formulaire.programme") }}*</label>
        <md-input v-model="programme" type="text"></md-input>
      </md-field>

      <div class="rad md-layout">
        <div class="md-layout-item md-size-50">
          <label>Destination souhaitée*</label>

          <br />
          <br />
          <md-radio v-model="pays" name="pays" value="France">France</md-radio>

          <br />
          <md-radio v-model="pays" name="pays" value="Canada">
            Canada
          </md-radio>

          <br />
          <md-radio v-model="pays" name="pays" value="USA">USA</md-radio>

          <br />
          <md-radio v-model="pays" name="pays" value="Turquie"
            >Turquie</md-radio
          >

          <br />
          <md-radio v-model="pays" name="pays" value="Albanie"
            >Albanie</md-radio
          >
        </div>

        <div class="md-layout-item md-size-50" v-if="procedure === 'Travail'">
          <label>Permis de Travail*</label>

          <br />
          <br />
          <md-radio v-model="permis" value="Ouvert">Ouvert</md-radio>

          <br />
          <md-radio v-model="permis" value="Fermé">
            Fermé
          </md-radio>
        </div>
      </div>

      <md-field v-if="procedure === 'Etude'">
        <label>Programme d'étude souhaité*</label>
        <md-input v-model="programmeChoix" name="cible" type="text"></md-input>
      </md-field>

      <md-field v-if="procedure === 'Business' || procedure === 'Travail'">
        <label>Nombre d’année d’expérience dans votre domaine*</label>
        <md-input v-model="experience" name="experience" type="text"></md-input>
      </md-field>

      <md-field>
        <label>Autres informations</label>
        <md-input v-model="autreInfo" type="text"></md-input>
      </md-field>

      <div v-if="error === true" class="text-danger text-center alert-danger">
        {{ $t("echec") }}
      </div>

      <div
        v-if="success === true"
        class="text-success text-center alert-success"
      >
        {{ $t("success") }}
      </div>

      <div style="text-align: center">
        <pulse-loader
          :loading="loading"
          color="black"
          size="20px"
        ></pulse-loader>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-33 mx-auto text-center">
          <md-button class="md-info" type="submit" value="Send">
            {{ $t("landing.formulaire.envoyer") }}
          </md-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { db } from "@/main";
import axios from "axios";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  bodyClass: "landing-page",

  components: {
    PulseLoader
  },

  data() {
    return {
      name: "",
      email: "",
      message: "Test",
      error: false,
      success: false,
      phone: "",
      nationalite: "",
      procedure: "",
      pays: "",
      niveau: "",
      objet: "alleluia",
      programmeChoix: "",
      programme: "",
      experience: "",
      permis: "",
      loading: false,
      autreInfo: "-",
      date: "",
      lieu: ""
    };
  },

  methods: {
    isNumberOnly($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 42 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    sendEmail(id) {
      const data = {
        service_id: "service_944rkdp",
        template_id: "template_nxanzbs",
        user_id: "ScwOFQla9WLx6WNC_",
        template_params: {
          username: this.name,
          lien: "https://revelation-travel-4556e.web.app/#/pdfTok?id=" + id,
          email: this.email,
          phone: this.phone,
          nationalite: this.nationalite,
          procedure: this.procedure,
          niveau: this.niveau,
          pays: this.pays,
          cible: this.programmeChoix,
          programme: this.programme,
          experience: this.experience,
          permis: this.permis,
          autreInfo: this.autreInfo,
          date: this.date,
          lieu: this.lieu
        }
      };

      axios
        .post("https://api.emailjs.com/api/v1.0/email/send", data)
        .then(
          result => {
            console.log("SUCCESS!", result.text);
          },
          error => {
            console.log("FAILED...", error.text);
          }
        )
        .catch(error => {
          console.log(error);
        });
    },

    save() {
      if (
        this.name.length > 0 &&
        this.email.length > 0 &&
        this.nationalite.length > 0 &&
        this.pays.length > 0 &&
        this.procedure.length > 0 &&
        this.niveau.length > 0 &&
        this.phone.length > 0
      ) {
        this.error = false;
        this.loading = true;
        let createdat = new Date().getTime();

        const document = db.collection("souscriptions").doc();

        document
          .set({
            id: document.id,
            name: this.name,
            email: this.email,
            nationalite: this.nationalite,
            pays: this.pays,
            niveau: this.niveau,
            procedure: this.procedure,
            choix: this.programmeChoix,
            oldProgramme: this.programme,
            isRead: false,
            createdAt: createdat,
            phone: this.phone,
            experience: this.experience,
            permis: this.permis,
            autreInfo: this.autreInfo,
            dateNaissance: this.date,
            lieu: this.lieu
          })
          .then(response => {
            this.success = true;
            console.log(response);
            this.loading = false;
            this.sendEmail(document.id);
          })
          .catch(error => {
            console.error("Error: ", error);
          });
      } else {
        this.error = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.md-success {
  margin-top: 3rem;
}
.hooper {
  height: auto;
}
.rad {
  margin-top: 30px;
}
.alert-success,
.alert-danger {
  margin-top: 50px;
}
</style>
